import { render, staticRenderFns } from "./SupplierPage.vue?vue&type=template&id=49890ece&scoped=true&"
import script from "./SupplierPage.vue?vue&type=script&lang=ts&"
export * from "./SupplierPage.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierPage.vue?vue&type=style&index=0&id=49890ece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49890ece",
  null
  
)

export default component.exports